import { handleErrors } from "helpers/utils/errors";
import styles from "./TagReadInput.module.scss";
import i18n from "i18n";
import { handleInputChange } from "react-select/dist/index-ea9e225d.cjs.prod";
import Icon from "components/MainApp/atoms/Icon/icon";
import InputText from "components/MainApp/atoms/Forms/MainInput";

const TagReadInput = ({ searchValue, searchedValue, handleSubmit, error = false }) => {

    return (
        <form onSubmit={handleSubmit}>
            <div className={styles["input-with-icon"]}>
                <InputText
                    label={i18n.t("scan.or.enter.number.tagid")}
                    handleChange={searchValue}
                    value={searchedValue}
                    error={error}
                />
                <span className={styles["input-barcode-icon"]}>
                    <Icon name="barcode" width={24} height={20} fill={"#3C7AF5"} />
                </span>
            </div>
        </form>
    )
}

export default TagReadInput;